<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Gerenciar Participantes' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <div
    class="bottom-button-wrapper"
    *ngIf="userProvider.hasConfig(122) || userProvider.hasConfig(123)"
  >
    <ion-grid>
      <ion-row class="ion-justify-content-center">
        <ion-col size="10">
          <ion-button
            class="btn-default"
            expand="block"
            (click)="addParticipantes()"
          >
            {{ 'Adicionar Participante' | translate }}
            <i class="fa-solid fa-plus"></i>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>

  <div class="list-participantes">
    <ion-grid *ngFor="let participante of participantes">
      <ion-row class="participante-row" align-items-center>
        <ion-col size="2">
          <ion-avatar>
            <img [src]="participante.foto | image:' '" />
          </ion-avatar>
        </ion-col>

        <ion-col size="8" class="info-col">
          <ion-label>
            <h5>{{ participante.nome }}</h5>
            <p class="cargo-text">{{ participante.cargo }}</p>
          </ion-label>
        </ion-col>

        <ion-col size="2" class="icon-col">
          <ion-note (click)="detalhes(participante)">
            <ion-icon class="icon-list" name="ellipsis-vertical"></ion-icon>
          </ion-note>
        </ion-col>
      </ion-row>

      <ion-item-divider></ion-item-divider>
    </ion-grid>

    <ion-list *ngIf="!participantes.length">
      <sem-registro></sem-registro>
    </ion-list>
  </div>
</ion-content>
